import type { TranslateFn } from "#/lib/i18n.js";
import { BrandLogo, ChromeNav, getLocalizedHref } from "./shared.js";

export function HeaderEditorialLongform({ locale, t }: { locale: string; t: TranslateFn }) {
  return (
    <header
      data-public-chrome="header"
      className="border-b border-[color:var(--color-border-subtle)] bg-[color:var(--color-bg-base)]"
    >
      <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex justify-center">
          <BrandLogo href={getLocalizedHref(locale, "/")} t={t} size="lg" centered />
        </div>
        <div className="mt-3 flex flex-col items-center gap-2 border-t border-[color:var(--color-border-subtle)] pt-3 sm:flex-row sm:justify-between">
          <p className="font-serif text-lg text-[color:var(--color-fg-default)]">
            {t("chrome.masthead.title")}
          </p>
          <ChromeNav locale={locale} t={t} />
        </div>
      </div>
    </header>
  );
}
